/**
 * Gex scripts
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';
import { hasGroup, resolveRoot } from '../shared/utils.js';

import $ from 'jquery';
import iziToast from 'izitoast';

injector.injectClass(class extends Script {
    onLoad() {
        const group = $('.gex-hide-widget').data('group');

        const $gexw = $('.gex-hide-widget input');
        if ($gexw) {
            $gexw.prop('checked', !hasGroup(group));
        }

        let loading = false;
        $gexw.on('change', () => {
            let catalog = 'expressions';
            if (group.includes('grammar')) catalog = 'grammar';

            if (loading) return false;
            loading = true;
            $.getJSON(resolveRoot(`gex-course/toggle-gex/${catalog}`)).then((res) => {
                if (res.status !== 'ok') {
                    console.error(res.message);
                }
                loading = false;
            }).fail((res) => {
                console.error(res);
                loading = false;
            });
        });

        this._initConfirm();
    }

    _initConfirm() {
        $('body').on('click', '[data-gex-confirm]', function (e) {
            e.preventDefault();

            const $a = $(this);
            const id = $a.data('id');
            if (id) {
                if (localStorage.getItem(`gex-confirm-popup-shown-${id}`) === 'true') {
                    location.href = $a.attr('href');
                    return;
                }
            }

            const dont = [];
            if (id) {
                dont.push(["<button><b>YES</b> (don't show again)</button>", (instance, toast) => {
                    localStorage.setItem(`gex-confirm-popup-shown-${id}`, 'true');
                    location.href = $a.attr('href');
                    instance.hide(transition, toast, 'button');
                }, true]);
            }

            const transition = { transitionOut: 'fadeOut' };
            iziToast.warning({
                timeout: 20000,
                close: false,
                overlay: true,
                toastOnce: true,
                zindex: 999,
                title: $a.data('gex-confirm'),
                position: 'center',
                buttons: [
                    ['<button><b>YES</b></button>', (instance, toast) => {
                        location.href = $a.attr('href');
                        instance.hide(transition, toast, 'button');
                    }],
                    ...dont,
                    ['<button><b>CANCEL</b></button>', (instance, toast) => {
                        instance.hide(transition, toast, 'button');
                    }, true],
                ],
            });

            return false;
        });
    }
});
